import React from 'react';
import MainProvider from './view/MainProvider';

class App extends React.Component {
  render() {
    return (
      <div>
        <MainProvider />
      </div>
    );
  }
}

export default App;
